// @ts-strict-ignore
import type { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { createContext } from 'react';
import type { AggregationSourceData } from './types';
import { AggregationEditorOrigin } from '../NodeEditorDrawer/types';

export type AggregationEditorContextType = {
  sourceData: AggregationSourceData;
  setSourceData: Dispatch<SetStateAction<AggregationSourceData>>;
  handleClose: () => void;
  /** Ref for the aggregation editor root container; used for keyboard focus scope (mirrors MLA mlaEditorPanelBoxContainerRef). */
  aggregationEditorContainerRef: MutableRefObject<HTMLDivElement | null>;
  /** Which editor surface opened this aggregation editor (threshold left, right, or data route). */
  origin: AggregationEditorOrigin;
};

export const AggregationEditorContext = createContext<AggregationEditorContextType>({
  sourceData: {} as AggregationSourceData,
  setSourceData: () => {},
  handleClose: () => {},
  aggregationEditorContainerRef: { current: null },
  origin: AggregationEditorOrigin.THRESHOLD_LEFT,
});
